
import IconAsap from '~/components/icon/IconAsap.vue';
import IconCalendarAlt from '~/components/icon/IconCalendarAlt.vue';
import IconCalendarSpecific from '~/components/icon/IconCalendarSpecific.vue';
import IconCalendarWeekend from '~/components/icon/IconCalendarWeekend.vue';
import IconDaytime from '~/components/icon/IconDaytime.vue';
import IconEvening from '~/components/icon/IconEvening.vue';

export default {
    name: 'JobRow',
    props: {
        /**
         * Job Object
         */
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        dateIcon() {
            switch (this.job.preferred_collection) {
                case 'asap':
                    return IconAsap;
                case 'daytime':
                    return IconDaytime;
                case 'evenings':
                    return IconEvening;
                case 'flexible':
                    return IconCalendarAlt;
                case 'weekends':
                    return IconCalendarWeekend;
                default:
                    return IconCalendarSpecific;
            }
        },
        distance() {
            if (this.job.distance) {
                return ` - ${this.job.distance} ${this.job.distance_format}`;
            }

            return '';
        },
    },
};
